import { layoutSchema } from '~/utils/crystallize/layout'

export function useLayoutCmsData() {
  const options = useCatalogueQueryOptions({ path: '/layout', schema: layoutSchema })

  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}
